/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WarningWord200ResponseResultData,
    WarningWord200ResponseResultDataFromJSON,
    WarningWord200ResponseResultDataFromJSONTyped,
    WarningWord200ResponseResultDataToJSON,
} from './WarningWord200ResponseResultData';

/**
 * warning_word_api の 200 レスポンス
 * @export
 * @interface WarningWord200Response
 */
export interface WarningWord200Response {
    /**
     * result が存在するかどうか
     * @type {boolean}
     * @memberof WarningWord200Response
     */
    result: boolean;
    /**
     * 
     * @type {WarningWord200ResponseResultData}
     * @memberof WarningWord200Response
     */
    resultData: WarningWord200ResponseResultData;
    /**
     * ステータスコードの文字列
     * @type {string}
     * @memberof WarningWord200Response
     */
    status: string;
}

export function WarningWord200ResponseFromJSON(json: any): WarningWord200Response {
    return WarningWord200ResponseFromJSONTyped(json, false);
}

export function WarningWord200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarningWord200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': json['result'],
        'resultData': WarningWord200ResponseResultDataFromJSON(json['result_data']),
        'status': json['status'],
    };
}

export function WarningWord200ResponseToJSON(value?: WarningWord200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
        'result_data': WarningWord200ResponseResultDataToJSON(value.resultData),
        'status': value.status,
    };
}

